import store from 'Site/js/store';
import Vue from 'vue';

export default function () {

    new Vue({ /* eslint no-new: 0 */
        el: '#page-body',
        data() {
            return {
                actionUrl: ''
            };
        },
        methods: {
            deleteVouch(action, confirmMessage) {
                this.actionUrl = action;
                if (confirmMessage) {
                    this.$store.dispatch('showConfirm', {
                        text: confirmMessage,
                        callback: () => {
                            document.querySelector('#profile-vouches-form').submit();
                        }
                    });
                }
            }
        },
        store
    });
}
